export default __webpack_public_path__ + "static/media/icon.fdec40f2.svg";